<template>
  <main id="main">
    <template v-if="$page">
      <NoteSection :content="$page.header" class="--first --activities" />
      <section class="section section__content --activities" id="f">
        <div class="activity__filter-bar" ref="activities" v-reveal="{ delay: 250 }">
          <ActivityFilters />
          <form action="" @submit.prevent class="activity__search">
            <div class="activity__search-field">
              <label for="search">{{ $t('activities.search') }}</label>
              <input
                type="text"
                id="search"
                name="search"
                :placeholder="$t('activities.search')"
                v-model="search"
              />
              <Icon id="search" />
            </div>
          </form>
        </div>
        <TransitionGroup
          class="activity__card-list"
          tag="ul"
          name="activity-card-transition"
          ref="activities"
          v-reveal="{ delay: 300 }"
        >
          <ActivityCard
            :activity="activity"
            v-for="activity in filteredActivities"
            :key="`${filteredActivities.length}-${activity.id}`"
            class="--index"
          />
        </TransitionGroup>
        <button
          class="button --centered --top"
          v-if="currentActivityLength < categoryFilteredActivities.length"
          @click="increment"
          :title="$t('activities.more')"
        >
          {{ `+ ${$t('activities.more')}` }}
        </button>
        <Transition name="fade">
          <p v-if="!filteredActivities.length">
            {{ $t('activities.empty') }}
          </p>
        </Transition>
      </section>
    </template>
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
  </main>
</template>

<script>
import { ActivityFilters } from '@/components/blocks'
import { ActivityCard } from '@/components/cards'
import { Icon } from '@/components/global'
import { NoteSection } from '@/components/sections'
import { Loader } from '@/components/small'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Activities',
  mixins: [PageMetaMixin],
  beetPage: 'activities',
  components: {
    ActivityCard,
    ActivityFilters,
    Icon,
    Loader,
    NoteSection,
  },
  data() {
    return {
      currentActivityLength: 15,
      incrementSize: 15,
      search: '',
    }
  },
  computed: {
    categoryFilteredActivities() {
      let activities = this.$store.state.activities.items

      if (this.$route.query.c) {
        const filterCategory = this.$store.getters.categoriesSlugMap[this.$route.query.c]
        if (filterCategory) return activities.filter(({ category }) => category === filterCategory)
      }

      return activities
    },
    filteredActivities() {
      let activities = this.categoryFilteredActivities

      if (this.search) {
        activities = activities.filter(
          ({ description, short_description, title }) =>
            title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
            short_description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
            description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1,
        )
      }

      return activities.slice(0, this.currentActivityLength)
    },
  },
  methods: {
    increment() {
      const oldHeight = this.$refs.activities.$el.scrollHeight
      this.currentActivityLength = this.currentActivityLength + this.incrementSize
      window.scrollTo({
        top:
          this.$refs.activities.$el.getBoundingClientRect().top +
          document.documentElement.scrollTop +
          oldHeight -
          100,
        behavior: 'smooth',
      })
    },
  },
  watch: {
    $route() {
      this.currentActivityLength = this.incrementSize
    },
  },
}
</script>
